import React from 'react'
import styled from 'styled-components'

import phone from '../../assets/icons/phone.svg'
import mapPin from '../../assets/icons/map-pin.svg'
import instagram from '../../assets/icons/instagram.svg'
import mail from '../../assets/icons/mail.svg'

export default props => {
  return (
    <Container {...props} id="contact__modal">
      <Title style={{ marginBottom: 15 }}>Наши контакты</Title>

      <Item href="tel:+996501118888" icon={phone} label="+996 501 11 88 88" />
      <Item icon={mapPin} label=г. Бишкек, ул.Исанова., 41" />
      <Item
        href="http://Instagram.com/chinapro.group"
        icon={instagram}
        label="@chinapro.group"
      />
      <Item
        href="mailto:info@chinapro.kg"
        icon={mail}
        label="info@chinapro.kg"
      />
    </Container>
  )
}

const Container = styled.div`
  width: 300px;
  position: absolute;
  top: ${props => (props.isOpen ? '-5px' : '-300px')};
  right: 0px;
  background-color: #fff;
  z-index: 9999;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 15px;
  transition: all 0.5s;
`

const Item = ({ href = '#', icon, label }) => (
  <Link href={href}>
    <Icon src={icon} alt={label} />
    <div>{label}</div>
  </Link>
)

const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #151515;
`

const Link = styled.a`
  color: rgba(21, 21, 21, 0.7);
  margin-top: 10px;
  display: flex;
  font-size: 14px;
  align-items: center;
`
const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 15px;
`
